import React from "react";
import { Button, StyledText } from "../../../../components/common";
import { CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import CorrectIcon from "../../../../components/images/correct-icon.png";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 0px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const SurveyAlreadyAnsweredModal = ({ isOpen, onClose }) => {
  const { themeContext, theme } = useTheme();
  const history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const token = JSON.parse(localStorage.getItem("token"));

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <Header>
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </Header>
        <StyledText style={{ fontSize: 20 }}>
          Survey Already Answered
        </StyledText>
        {/* <SuccessBoxIcon width="112" height="112" fill={background} /> */}
        <img src={CorrectIcon} alt="icon" style={{ width: "90px" }} />
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
          }}
        >
          Thank you for your input! You've already completed this month's
          survey. Stay tuned for next month's opportunity to share your
          feedback.
        </StyledText>
        <Button
          style={{
            backgroundColor: background,
            width: "80%",
            marginTop: "11px",
          }}
          onClick={onClose}
        >
          <StyledText color="white">Ok</StyledText>
        </Button>
      </ModalContent>
    </>
  );
};

export default SurveyAlreadyAnsweredModal;
